import { FC } from 'react';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import { BrochureProduct, CustomProduct, getBrochureProductImage } from '../../api/brochures';
import { getRequestedLanguages } from '../../locale/languages';

interface Props {
    product: BrochureProduct;
    customProduct?: CustomProduct;
    isDeleting: boolean;
    onConfigure?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
}

const BrochureProductRow: FC<Props> = ({ product, customProduct, isDeleting, onConfigure, onEdit, onDelete }) => {
    const language = getRequestedLanguages(window.errea_accountUserData.language);
    const image = getBrochureProductImage(product, customProduct);
    const isCustomProduct = !!customProduct;
    const isConfigured = isCustomProduct;
    const canConfigure = !!onConfigure && !isCustomProduct && product.is_configurable; // Prod mode  -- Check if product is configurable
    // const canConfigure = !!onConfigure && !isCustomProduct; // Debug mode -- Do not check if product is configurable
    const canEdit = !!customProduct && !!onEdit;
    const canDelete = !!onDelete;

    return (
        <div className={`brochureDetailProductRow${isCustomProduct ? ' brochureDetailProductRow--custom' : ''}`}>
            <div className="brochureDetailProductImage">
                {image ? (
                    <img src={image} alt={product.name} />
                ) : (
                    <div className="brochureDetailProductImagePlaceholder" />
                )}
            </div>
            <div className="brochureDetailProductInfo">
                <div className="brochureDetailProductTitleRow">
                    <span className="brochureDetailProductName">{product.name}</span>
                    {isConfigured && (
                        <span className="brochureDetailConfiguredBadge">{language.brochures.detail.configured}</span>
                    )}
                </div>
                <span className="brochureDetailProductSku">{product.sku}</span>
                <span className="brochureDetailProductColor">
                    {`${language.brochures.detail.color}: `}
                    <span className="highlighted">{product.color}</span>
                </span>
            </div>
            {(canConfigure || canEdit || canDelete) && (
                <div className="brochureDetailProductActions">
                    {canConfigure && (
                        <ButtonComponent
                            style="link"
                            text={language.brochures.detail.configure_product}
                            icon_left="magicpen"
                            onClick={onConfigure}
                        />
                    )}
                    {canEdit && customProduct && (
                        <ButtonComponent
                            style="link"
                            text={language.brochures.detail.edit_product}
                            icon_left="edit"
                            onClick={onEdit}
                        />
                    )}
                    {canDelete && (
                        <div
                            className={`brochureDetailTrashBtn${isDeleting ? ' brochureDetailTrashBtn--disabled' : ''}`}
                            onClick={!isDeleting ? onDelete : undefined}
                        >
                            <i className="icon errea-trash"></i>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default BrochureProductRow;
